import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hub-template-save-modal',
  styleUrls: [
    './template-save-modal.component.less',
  ],
  templateUrl: './template-save-modal.component.html',
})
export class HubTemplateSaveModalComponent {
  @Input() dialogId: string = 'saveAsTemplateDialog';
  @Input() dialogTitle: string = 'Save as template';
  @Input() name: string;
  @Input() global: boolean = false;
  @Input() description: string;
  @Input() title: string;
  @Input() burtAdmin: boolean;
  @Input() approveButtonTitle: string = 'Save Template';
  @Input() app: 'dashboard' | 'report';
  @Output() saveChange = new EventEmitter<{ name: string, description: string, global: boolean }>();

  public invalidNameError: boolean = false;

  public save(event) {
    this.invalidNameError = false;
    const pattern = new RegExp('^[a-zA-Z0-9_ .-]*$');
    if (!this.name.match(pattern)) {
      this.invalidNameError = true;
      event.stopPropagation();
    } else {
      this.saveChange.emit({ name: this.name, description: this.description, global: this.global || false });
    }
  }

  public get isDashboardApp() {
    return this.app === 'dashboard';
  }
}
